import React from 'react'
import { RouteObject } from 'react-router-dom'
import App from './App'

// For SSG compatibility, import page components directly
// These are already memoized components, not lazy-loaded during SSG
import { HomePage } from './pages/HomePage'
import { AboutPage } from './pages/AboutPage'
import { ContactPage } from './pages/ContactPage'
import { PerformancePage } from './pages/PerformancePage'
import { NotFoundPage } from './pages/NotFoundPage'

import { RouteLazyBoundary } from './components/common/LazyLoadingBoundary'

// Define routes for vite-react-ssg static generation
// Using nested routes where App component acts as the layout
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: (
          <RouteLazyBoundary routeName="home">
            <HomePage />
          </RouteLazyBoundary>
        ),
        // Pre-generate this route at build time
        loader: async () => {
          // This loader will run at build time for SSG
          return {
            title: 'Multi-Provider Static Site Template',
            description: 'Deploy your React app to AWS CloudFront, Netlify, Vercel, or Cloudflare Pages',
            lastModified: new Date().toISOString()
          }
        }
      },
      {
        path: 'about',
        element: (
          <RouteLazyBoundary routeName="about">
            <AboutPage />
          </RouteLazyBoundary>
        ),
        loader: async () => {
          return {
            title: 'About - Multi-Provider Template',
            description: 'Learn about this multi-provider static site template and its features',
            lastModified: new Date().toISOString()
          }
        }
      },
      {
        path: 'contact',
        element: (
          <RouteLazyBoundary routeName="contact">
            <ContactPage />
          </RouteLazyBoundary>
        ),
        loader: async () => {
          return {
            title: 'Contact - Multi-Provider Template',
            description: 'Get in touch with us about the multi-provider static site template',
            lastModified: new Date().toISOString()
          }
        }
      },
      {
        path: 'performance',
        element: (
          <RouteLazyBoundary routeName="performance">
            <PerformancePage />
          </RouteLazyBoundary>
        ),
        loader: async () => {
          return {
            title: 'Performance Dashboard - Multi-Provider Template',
            description: 'Monitor and optimize performance across all deployment providers',
            lastModified: new Date().toISOString()
          }
        }
      },
      {
        path: '*',
        element: (
          <RouteLazyBoundary routeName="404">
            <NotFoundPage />
          </RouteLazyBoundary>
        ),
        loader: async () => {
          return {
            title: '404 - Page Not Found',
            description: 'The page you are looking for does not exist',
            lastModified: new Date().toISOString()
          }
        }
      }
    ]
  }
]

// Static paths that should be pre-generated at build time
export const getStaticPaths = async () => {
  return [
    '/',
    '/about', 
    '/contact',
    '/performance'
    // Note: 404 page (*) should not be in static paths as it's a catch-all
  ]
}

export default routes